// Event names for the embed onboarding flow.
// Single source of truth — import from here at every call site so renames
// stay in sync and a typo can't silently split an event into two.
export const EMBED_EVENTS = {
  ONBOARDING_VIEWED: 'embed_onboarding_viewed',
  DEMO_MODAL_SHOWN: 'embed_demo_modal_shown',
  DEMO_CTA_CLICKED: 'embed_demo_cta_clicked',
  DEMO_MODAL_DISMISSED: 'embed_demo_modal_dismissed',
  PROMPT_STARTED: 'embed_prompt_started',
  /** A draft prompt saved on a previous visit was restored into the box. */
  PROMPT_RESTORED: 'embed_prompt_restored',
  BUILD_CLICKED: 'embed_build_clicked',
  ADMIN_BLOCK_SHOWN: 'embed_admin_block_shown',
  ADMIN_BLOCK_DISMISSED: 'embed_admin_block_dismissed',
  ADMIN_EXTERNAL_CLICKED: 'embed_admin_external_clicked',
  TRIAL_CONFIRMED: 'embed_trial_confirmed',
  /** Trial-confirm modal closed WITHOUT confirming — the key abandonment moment. */
  TRIAL_DECLINED: 'embed_trial_declined',
  WORKSPACE_PROVISIONED: 'embed_workspace_provisioned',
  /** Industry-personalized "try a live demo" card opened. */
  DEMO_APP_OPENED: 'embed_demo_app_opened',
} as const;

export type EmbedEvent = (typeof EMBED_EVENTS)[keyof typeof EMBED_EVENTS];
